package com.wintermar.inspection.feature.presentation.template.widget.preview

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.component.TextBodyLarge
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.datetime.util.DateTimeUtil
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.feature.presentation.template.landing.TemplateLandingState


@Composable
fun TemplatePreview(
    paddingValues: PaddingValues,
    state: TemplateLandingState,
    topPadding: Dp,
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension,
) {
    val defaultPadding = dimension.spacing.space4
    val expandedSections = remember { mutableStateMapOf<String, Boolean>() }
    val density = LocalDensity.current
    val screenHeightDp = with(density) {
        LocalWindowInfo.current.containerSize.height.toDp()
    } - paddingValues.calculateBottomPadding()

    LazyColumn(
        modifier = Modifier.height(screenHeightDp)
            .padding(
                horizontal = defaultPadding,
            )
    ) {
        itemHeaderContent(
            state = state,
            topPadding = topPadding,
            defaultPadding = defaultPadding,
            color = color
        )

        state.detailTemplate.pages.forEach { page ->

            // PAGE HEADER (Top of the Page Container)
            item(key = "page_head_${page.id}") {
                PageHeader(title = page.title)
            }

            page.sections.forEach { section ->
                val isExpanded = expandedSections[section.id] ?: false

                // SECTION ROW
                item(key = section.id) {
                    SectionRow(
                        title = section.title,
                        isExpanded = isExpanded,
                        modifier = Modifier.animateItem(),
                        onClick = { expandedSections[section.id] = !isExpanded }
                    )
                }

                // QUESTIONS (Flattened items)
                if (isExpanded) {
                    items(
                        items = section.questions,
                        key = { it.id }
                    ) { question ->
                        QuestionRow(
                            question = question,
                            modifier = Modifier.animateItem()
                        )
                    }
                }
            }

            // PAGE FOOTER (Closes the visual container)
            item(key = "page_foot_${page.id}") {
                PageFooter()
            }
        }
    }
}

expect fun LazyListScope.itemHeaderContent(
    state: TemplateLandingState,
    topPadding: Dp,
    defaultPadding: Dp,
    color: ThemeColor
)
